/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { globalLoadingOff, globalLoadingOn } from "../slices/globalLoading/globalLoadingSlice";
import { selectCurrentUserApiToken, selectCurrentUserFavoriteFois, selectCurrentUserId } from "../slices/currentUser/currentUserSlice";
import getResourcesTitlesAndTypes from "../functions/getResourceTitlesAndTypesAPI";
import updateUserFavorites from "../functions/updateUserFavoritesAPI";

const updateFavorites = async (addToast, favoriteFOIsState, setFavoriteFOIsState, resourceId, apiToken) => {
    let foi = parseInt(resourceId);
    let removeFromFavorites = favoriteFOIsState.includes(foi);
    //This set State is to get instant webpage feedback of the star displaying while it submits to the server
    setFavoriteFOIsState((prevState) => {
        if (removeFromFavorites) {
            prevState.splice(prevState.indexOf(foi), 1);    //removes foi from list
        } else {
            prevState.push(foi);        //otherwise add it
        }
        return [...prevState];
    });

    let response = await updateUserFavorites(foi, apiToken, removeFromFavorites);
    if (response?.success) {
        if (removeFromFavorites) {
            addToast('Removed from your favorites.', { appearance: 'success' });
        } else {
            addToast('Added to your favorites.', { appearance: 'success' });
        }
        if (response.favoritefois && favoriteFOIsState.toString() !== response.favoritefois.toString()) {
            setFavoriteFOIsState(response.favoritefois);
        }
    } else if (response?.errormessage) {
        addToast(response.errormessage, { appearance: 'error' });
    } else {
        addToast('Problem updating your favorites.', { appearance: 'error' });
    }
}

const FavoriteResourceStar = ({ resourceId, absolutePosition, topOffset, rightOffset, fontSize }) => {

    const apiToken = useSelector(selectCurrentUserApiToken);
    const favoriteFois = useSelector(selectCurrentUserFavoriteFois);
    const userId = useSelector(selectCurrentUserId);
    const isLoggedIn = (!!userId && userId !== "1");
    const { addToast } = useToasts();

    let favorited = false;
    if (resourceId && favoriteFois) {
        let initialFavoriteFois = JSON.parse(JSON.stringify(favoriteFois));
        if (initialFavoriteFois?.includes(parseInt(resourceId))) {
            favorited = true;
        }
    }

    const [favoriteFOIsState, setFavoriteFOIsState] = useState([]);
    const [favoritedState, setFavoritedState] = useState(favorited);

    useEffect(() => {
        if (favoriteFois) {
            setFavoriteFOIsState(JSON.parse(JSON.stringify(favoriteFois)));
        }
    }, [favoriteFois]);

    fontSize = fontSize || "30px";
    let style = { fontSize: fontSize, cursor: "pointer" };
    if (absolutePosition) {
        style.position = "absolute";
        style.zIndex = "1000";
        style.top = topOffset || "5px";
        style.right = rightOffset || "3px";
    }

    return <>{isLoggedIn &&
        <div style={style}
            title={favoritedState === true ? "Favorited, click to remove from favorites" : "Add to favorites"}
            onClick={() => {
                setFavoritedState(prevState => { return !prevState });
                updateFavorites(addToast, favoriteFOIsState, setFavoriteFOIsState, resourceId, apiToken);
            }}>
            {favoritedState === true ? <span className="favoriteStarSelected">★</span> : <>✩</>}
        </div>
    }</>
}

//MAKE ALPHABETICAL ORDER?
const FhirResourcesLinks = ({ favoriteFois, favoritedResourcesDictState }) => {
    return <div style={{ "textAlign": "left" }}>
        {favoriteFois.map((foi, index) => {
            let relativeUrl = "/" + foi;
            let title = foi;
            let status;
            let resourceEntry = favoritedResourcesDictState[foi];
            if (resourceEntry) {
                relativeUrl = resourceEntry.relativeUrl;
                title = resourceEntry.title;
                status = resourceEntry.status;
            }
            return <div key={index} style={{ display: "flex", paddingBottom: "4px" }}>
                <FavoriteResourceStar resourceId={foi} fontSize={"24px"} />
                &nbsp;
                <Link to={relativeUrl}>
                    <span style={{ fontSize: "24px" }}>{title}</span>
                </Link><span>{status !== "active" && <>&nbsp;&nbsp;({status})</>}</span>
            </div>
        })}
    </div>
};

// eslint-disable-next-line no-empty-pattern
const FavoriteResourcesSection = ({ }) => {
    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const favoriteFois = useSelector(selectCurrentUserFavoriteFois);

    const [loadedFavoritesState, setLoadedFavoritesState] = useState([]);
    //const [globalLoadingState, setGlobalLoadingState] = useState(true);
    const [favoritedResourcesDictState, setFavoritedResourcesDictState] = useState({});

    const loadFavorites = async () => {
        if (apiToken) { // && globalLoadingState
            let numberOfFavorites = favoriteFois.length;
            if (numberOfFavorites > 0 && Object.keys(favoritedResourcesDictState).length !== numberOfFavorites &&
                loadedFavoritesState.toString() !== favoriteFois.toString()) {
                //LOADING
                setLoadedFavoritesState([...favoriteFois]);
                //DO SERVER CALL
                //setGlobalLoadingState(true);
                dispatch(globalLoadingOn());
                let response = await getResourcesTitlesAndTypes(favoriteFois, apiToken);
                if (response.success) {
                    setFavoritedResourcesDictState(response.resources);
                }
                //setGlobalLoadingState(false);
                dispatch(globalLoadingOff());
            }
        }
    }

    useEffect(() => {
        if (apiToken) {
            loadFavorites();
        }
    }, [apiToken]);

    return <>
        {/*globalLoadingState
            &&
            <Dimmer className={"loadingDimmer"} active inverted>
                <Loader inverted>Loading</Loader>
            </Dimmer>
        */}
        {favoriteFois.length === 0 ?
            <h2>You haven't favorited any resources.</h2>
            :
            <FhirResourcesLinks favoriteFois={favoriteFois}
                favoritedResourcesDictState={favoritedResourcesDictState} />}
    </>
}
/*
const FavoriteResourcesPage = ({ }) => {
    const dispatch = useDispatch();
    const userId = useSelector(selectCurrentUserId);
    const isLoggedIn = (!!userId && userId !== "1");
    dispatch(changeBrowserTabTitle("FEvIR Favorites"));

    return (
        <div>
            <Segment className={`containerSegment remainderOfPageSegment`} raised>
                <>{!isLoggedIn ?
                    <h1>Please login to view your favorites</h1>
                    :
                    <FavoriteResourcesSection />
                }</>
            </Segment>
        </div>
    );
};
*/
export { FavoriteResourcesSection, FavoriteResourceStar };